import { render, staticRenderFns } from "./CategoriasAtendidas.vue?vue&type=template&id=09025bb1&scoped=true"
import script from "./CategoriasAtendidas.vue?vue&type=script&lang=js"
export * from "./CategoriasAtendidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09025bb1",
  null
  
)

export default component.exports